export class ExplicitWidth {
    selector = '.explicit-width';
    elements = [];

    constructor() {
        this.elements = document.querySelectorAll(this.selector);

        if (this.elements.length === 0) {
            return null;
        }

        this.update();
        this.bind();
    }

    bind() {
        document.addEventListener('DOMContentLoaded', this.onDOMContentLoaded.bind(this));
        window.addEventListener('load', this.onWindowLoad.bind(this));
        window.addEventListener('resize', this.onWindowResize.bind(this));
    }

    update() {
        this.elements.forEach(el => {
            el.style.width = '';
            el.style.width = `${el.getBoundingClientRect().width}px`;
        });
    }

    onDOMContentLoaded(event) {
        window.requestAnimationFrame(this.update.bind(this));
    }

    onWindowLoad(event) {
        window.requestAnimationFrame(this.update.bind(this));
    }

    onWindowResize(event) {
        window.requestAnimationFrame(this.update.bind(this));
    }
}